import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Container } from "@/components/site/PageHeader";

const IMGS = [
  "https://images.pexels.com/photos/1181769/pexels-photo-1181769.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.pexels.com/photos/6131931/pexels-photo-6131931.jpeg?auto=compress&cs=tinysrgb&w=1000",
  "https://images.pexels.com/photos/31853515/pexels-photo-31853515.jpeg?auto=compress&cs=tinysrgb&w=1000",
  "https://images.pexels.com/photos/10063279/pexels-photo-10063279.jpeg?auto=compress&cs=tinysrgb&w=1000",
];

const Tile = ({ src, className }) => (
  <div className={`overflow-hidden group ${className}`}>
    <img src={src} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
  </div>
);

export const CollageSection = () => (
  <section className="py-24 md:py-32 border-t border-white/10" data-testid="home-collage-section">
    <Container className="grid grid-cols-1 xl:grid-cols-2 gap-16 items-center [&>*]:min-w-0">
      <div className="grid grid-cols-6 grid-rows-6 gap-3 h-[520px] md:h-[640px]">
        <Tile src={IMGS[0]} className="col-span-4 row-span-4" />
        <Tile src={IMGS[1]} className="col-span-2 row-span-3" />
        <Tile src={IMGS[2]} className="col-span-2 row-span-3" />
        <Tile src={IMGS[3]} className="col-span-4 row-span-2" />
      </div>
      <div>
        <SectionHeading top="Au coeur" bottom="du mouvement" testId="home-collage-title" />
        <p className="text-zinc-300 text-base sm:text-lg leading-relaxed mt-10 max-w-xl">
          Les disquaires où l'on digge, les salles où l'on vibre, les bars où l'on se retrouve. En France comme à l'étranger, LGTDZ partage ses bons plans : ceux qui font vivre la musique au quotidien.
        </p>
        <div className="flex flex-wrap gap-4 mt-10">
          <Link to="/lieux/disquaires" data-testid="home-discover-places-btn" className="inline-flex items-center gap-3 bg-white text-black font-display uppercase text-xl px-8 py-4 hover:bg-primary hover:text-white transition-colors duration-200">
            Découvrir les lieux <ArrowRight className="w-5 h-5" />
          </Link>
          <Link to="/artistes" data-testid="home-artists-btn" className="inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200">
            Les artistes
          </Link>
        </div>
      </div>
    </Container>
  </section>
);
